@if (isError == true) {
  <div class="">
    <div class="max-w-3xl mx-auto space-y-4 pb-8 font-light text-md">
      <h1 class="text-center font-bold text-2xl">Ungültiger Link</h1>
      <p class="text-center">
        <a [routerLink]="['/']">zurück zur Startseite</a>
      </p>
    </div>
  </div>
} @else if (isError == false) {
  <div class="">
    <div class="max-w-3xl mx-auto space-y-4 pb-8 font-light text-md">
      <h1 class="text-center font-bold text-2xl">Meldung nach § 146a Abs. 4 AO</h1>
      <p class="text-sm text-gray-500 text-center">
        ID: {{ id }}
      </p>
      <div class="bg-white rounded-md px-8 py-4 shadow-sm mt-3">
        <p>
          Gemäß § 146a Absatz 4 Abgabenordnung (AO) sind Unternehmen verpflichtet, Änderungen an den im Betrieb
          eingesetzten
          elektronischen Aufzeichnungssystemen (z. B. Kassensysteme) und den damit verbundenen Sicherheitsmodulen zu
          melden.
          <br/><br/>
          Per E-Mail haben wir Ihnen eine Übersicht der aktuell in Ihrem Kassensystem aktiven Geräte und Module mit der
          oben
          gennanten ID, nach § 87d AO in leicht nachprüfbarer Form, vorgelegt.
          <br/><br/>
          Bitte prüfen Sie die Angaben sorgfältig, bevor Sie die Meldung bestätigen. Änderungen oder Ergänzungen können
          direkt
          im Rahmen dieser Rückmeldung mitgeteilt werden.
        </p>
      </div>
      <div class="bg-white rounded-md px-8 py-4 shadow-sm">
        <h2 class="fw-bold text-xl">Rechtliche Hinweise</h2>
        <ol class="list-decimal space-y-1">
          <li>
            Die in dem Dokument vermerkten Daten basieren auf den im System <span class="font-bold">CheqMe</span>
            registrierten Geräten und
            Sicherheitsmodulen.
          </li>
          <li>
            Nach § 146a AO i. V. m. § 87d AO sind diese Daten in einer Form darzulegen, die eine leichte Nachprüfung
            ermöglicht.
          </li>
          <li>
            Mit Ihrer Bestätigung bestätigen Sie, dass:
            <ul class="pl-8 list-disc">
              <li>die Angaben von Ihnen geprüft wurden,</li>
              <li>diese Angaben korrekt sind oder notwendige Anpassungen gemeldet werden,</li>
              <li>Ihnen die gesetzlichen Verpflichtungen bekannt sind.</li>
            </ul>
          </li>
        </ol>
      </div>
      <div class="bg-white rounded-md px-8 py-4 shadow-sm">
        <h2 class="fw-bold text-xl">Anmerkungen</h2>
        <fieldset class="">
          <p class="text-gray-600">Haben Sie Korrekturen oder Ergänzungen?</p>
          <div class="space-y-1 mt-2">
            <div class="flex items-center">
              <input (change)="comments = false" [checked]="!comments"
                     id="comments_no" name="comments"
                     type="radio"/>
              <label class="ml-3 block  text-gray-900" for="comments_no">Nein</label>
            </div>
            <div class="flex items-center">
              <input (change)="comments = true" [checked]="comments"
                     id="comments_yes" name="comments"
                     type="radio"/>
              <label class="ml-3 block  text-gray-900" for="comments_yes">Ja</label>
            </div>
          </div>
        </fieldset>
        <div *ngIf="comments" class="-m-0.5 rounded-lg p-0.5 mt-2">
          <label class="sr-only" for="comment">Comment</label>
          <div>
        <textarea [(ngModel)]="comment"
                  class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-theme-primary-600 sm:text-sm/6"
                  id="comment" name="comment" placeholder="Bitte geben Sie hier Ihre Anmerkungen ein..."
                  rows="5"></textarea>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-md px-8 py-4 shadow-sm">
        <div class="flex items-start">
          <input [(ngModel)]="confirmation" class="mt-1.5" id="checkbox" name="checkbox" type="checkbox"/>
          <label class="ml-3 block text-gray-900" for="checkbox">
            Ich bestätige, dass ich die angegebenen Daten geprüft habe und sie korrekt sind (bzw. Änderungen angegeben
            wurden).
          </label>
        </div>
      </div>

      <div class="bg-white rounded-md px-8 py-4 shadow-sm">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div></div>
          <button
            (click)="requestConfirmationCode()"
            [disabled]="!validateSubmission()"
            class="select-none disabled:pointer-events-none disabled:!bg-gray-400 ml-auto rounded-md bg-theme-primary-700 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-theme-primary-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-600"
            type="button">
            Abschicken
          </button>
        </div>
      </div>
    </div>
  </div>

  @if (popupVisible) {
    <div class="fixed cursor-pointer inset-0 bg-gray-400 opacity-50" (click)="popupVisible = false"></div>
    <div
      class="flex flex-col fixed left-1/2 -translate-x-1/2 top-1/3 -translate-y-1/2 rounded-xl shadow-xl bg-white max-w-xl w-full p-4 space-y-2">
      <h2 class="text-center font-bold text-2xl">Bestätigungscode eingeben</h2>
      <p class="text-center">Bestätigungscode wurde an die hinterlegte E-Mail-Adresse verschickt.</p>
      <div class="mx-auto">
        <ngx-otp-input [status]="status" #otp class="text-sm" (otpComplete)="send($event)"
                       (otpChange)="otpChanged()" [options]="options"></ngx-otp-input>
      </div>
      <div class="inline-flex mx-auto gap-x-2 mt-3">
        <button (click)="popupVisible = false"
                class="select-none disabled:pointer-events-none disabled:!bg-gray-400 mx-auto rounded-md  px-2.5 py-1.5 text-sm font-semibold text-gray-900 hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-600 border border-gray-300"
                type="button">
          Abbrechen
        </button>
      </div>
    </div>
  }
}
